// import { useEffect, useState } from "react";

// import Cookies from "js-cookie";


// // Reusable Circular Progress Component
// function CircularProgress({ value, max, label, color }) {
//   const radius = 50;
//   const strokeWidth = 8;
//   const circumference = 2 * Math.PI * radius;
//   const progress = (value / max) * circumference;

//   return (
//     <div className="tc">
//       <svg width="120" height="120" className="mb3">
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke="#e5e7eb" // gray background
//           strokeWidth={strokeWidth}
//           fill="none"
//         />
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke={color}
//           strokeWidth={strokeWidth}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={circumference - progress}
//           strokeLinecap="round"
//           transform="rotate(-90 60 60)"
//         />
//         <text
//           x="60"
//           y="65"
//           textAnchor="middle"
//           className="f4 fw6 dark-gray"
//         >
//           {value}
//         </text>
//       </svg>
//       <div className="f6 gray">{label}</div>
//     </div>
//   );
// }

// export default function RecordsDashboard() {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);


//   useEffect(() => {
//     //fetch agents
//     const fetchAll = () => {
//       let adminCookie = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1) {
//         setLoading(true);

//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/getRecords", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               userid: adminCookie,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].id >= 1) {
//                 //load data



//                 //new way to update the state event without duplicates
//                 // Update events using setEvents, excluding duplicates
               
//                 setRecords(user);
//         setLoading(false);
//               } else {
//                 //dont load

              
//                 setLoading(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setLoading(null);
//               // setFlag(1);
//             });
//         }, 2000);
//       } else {
//         setLoading(null);
//       }
//     };

//     fetchAll();
//   }, []);

//   const totalRecords = records.length;
// //   const totalWeight = records.reduce((sum, r) => sum + (r.weight || 0), 0);

// // ✅ Safely sum weights, converting string -> number
// const totalWeight = records.reduce(
//   (sum, r) => sum + (parseFloat(r.weight) || 0),
//   0
// ).toFixed(2); // Keep two decimal places

// // ✅ Dynamic max for progress bar: take the highest value + buffer
// const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100; 
// const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;

//   // if (loading) return <div className="pa4 gray">Loading...</div>;

//   return (
//     <div className="pa0">
//       {/* Progress Circles */}
//       <div className="flex flex-wrap justify-center gap4">
//   <CircularProgress
//     value={totalRecords}
//     max={recordsMax}
//     label="Total Records"
//     color="#3b82f6" // blue
//   />
//   <CircularProgress
//     value={totalWeight}
//     max={weightMax}
//     label="Total Weight (kg)"
//     color="#10b981" // green
//   />
// </div>


    
//     </div>
//   );
// }


// // new with icon
// import { useEffect, useState,useRef } from "react";
// import Cookies from "js-cookie";

// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   XAxis,
//  YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";

// // =====================
// // Circular Progress
// // =====================
// function CircularProgress({ value, max, label, color }) {
//   const radius = 50;
//   const strokeWidth = 8;
//   const circumference = 2 * Math.PI * radius;
//   const progress = max > 0 ? (value / max) * circumference : 0;

//   return (
//     <div className="tc">
//       <svg width="120" height="120" className="mb3">
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke="#e5e7eb"
//           strokeWidth={strokeWidth}
//           fill="none"
//         />
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke={color}
//           strokeWidth={strokeWidth}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={circumference - progress}
//           strokeLinecap="round"
//           transform="rotate(-90 60 60)"
//         />
//         <text
//           x="60"
//           y="65"
//           textAnchor="middle"
//           className="f4 fw6 dark-gray"
//         >
//           {value}
//         </text>
//       </svg>
//       <div className="f6 gray">{label}</div>
//     </div>
//   );
// }


// // ===== ADD THIS NEW COMPONENT HERE =====
// function ScrollableChart({ chartData, isMobile, children }) {
//   const [showRightFade, setShowRightFade] = useState(false);
//   const scrollRef = useRef(null);
//   const hasOverflow = chartData.length > 8;

//   useEffect(() => {
//     if (!hasOverflow) {
//       setShowRightFade(false);
//       return;
//     }
//     const el = scrollRef.current;
//     if (!el) return;

//     const checkScroll = () => {
//       const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 5;
//       setShowRightFade(!atEnd);
//     };

//     checkScroll();
//     el.addEventListener("scroll", checkScroll);
//     window.addEventListener("resize", checkScroll);
//     return () => {
//       el.removeEventListener("scroll", checkScroll);
//       window.removeEventListener("resize", checkScroll);
//     };
//   }, [hasOverflow, chartData.length]);

//   return (
//     <div style={{ position: "relative" }}>
//       <div
//         ref={scrollRef}
//         style={{ width: "100%", overflowX: hasOverflow ? "auto" : "visible" }}
//       >
//         {children}
//       </div>

//       {showRightFade && (
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             right: 0,
//             bottom: 0,
//             width: "36px",
//             pointerEvents: "none",
//             background:
//               "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.95))",
//           }}
//         />
//       )}

//       {hasOverflow && showRightFade && (
//         <div className="tc f7 gray mt1">← scroll for more →</div>
//       )}
//     </div>
//   );
// }
// // ===== END NEW COMPONENT ====

// // =====================
// // Dashboard
// // =====================
// export default function RecordsDashboard() {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [profile, setProfile] = useState(null);
//   const isMobile = useIsMobile();
// const [showChart, setShowChart] = useState(false);

//   useEffect(() => {
//     fetchDashboard();
//   }, []);

// const fetchDashboard = async () => {
//   try {
//     const userid = Cookies.get("sessioniduser") || "";

//     if (!userid) {
//       setLoading(false);
//       return;
//     }

//     const res = await fetch(
//       "https://api.terraweb.africa/getRecords",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ userid }),
//       }
//     );

//     const data = await res.json();

//     // safety check (important)
//     if (data?.profile) {
//       setProfile(data.profile || {});
//       setRecords(data.records || []);
//     } else {
//       // fallback for unexpected response
//       setProfile({});
//       setRecords([]);
//     }

//     setLoading(false);
//   } catch (err) {
//     console.error(err);
//     setLoading(false);
//   }
// };

//   // =====================
//   // DATE FILTER HELPERS
//   // =====================
//   const now = new Date();
//   const currentMonth = now.getMonth();
//   const currentYear = now.getFullYear();

//   const isThisMonth = (dateStr) => {
//     const d = new Date(dateStr);
//     return (
//       d.getMonth() === currentMonth &&
//       d.getFullYear() === currentYear
//     );
//   };

//   // =====================
//   // METRICS
//   // =====================
//   const totalRecords = records.length;

//   const monthlyRecords = records.filter((r) =>
//     isThisMonth(r.daterecorded)
//   ).length;

//   const approvedRecords = records.filter(
//     (r) => r.approved_status === "approved"
//   ).length;

//   const totalWeight = records
//     .reduce(
//       (sum, r) =>
//         sum + (parseFloat(r.weight) || 0),
//       0
//     )
//     .toFixed(2);

//   // dynamic max scaling
//   const recordsMax =
//     totalRecords > 0
//       ? totalRecords * 1.2
//       : 100;

//   const monthlyMax =
//     monthlyRecords > 0
//       ? monthlyRecords * 1.2
//       : 50;

//   const approvedMax =
//     totalRecords > 0
//       ? totalRecords
//       : 100;

//   const weightMax =
//     totalWeight > 0
//       ? totalWeight * 1.2
//       : 100;
// const getGenderAvatar = (gender) => {
//   switch (gender) {
//     case "female":
//       return "/img/femaleavatar.jpg";
//     case "male":
//       return "/img/maleavatar.jpeg";
//     default:
//       return "/img/maleavatar.png";
//   }
// };

// const grouped = {};

// records.forEach((r) => {
//   const day = new Date(r.daterecorded).toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "short",
//   });

//   if (!grouped[day]) {
//     grouped[day] = {
//       date: day,
//       milk: 0,
//       coffee: 0,
//       tea: 0,
//     };
//   }

//   const weight = Number(r.weight);

//   switch (r.producttype.toLowerCase()) {
//     case "milk":
//       grouped[day].milk += weight;
//       break;

//     case "coffee":
//       grouped[day].coffee += weight;
//       break;

//     case "tea leaves":
//       grouped[day].tea += weight;
//       break;
//   }
// });

// const chartData = Object.values(grouped);

// const milkTotal = records
//   .filter(r => r.producttype === "milk")
//   .reduce((s, r) => s + Number(r.weight), 0);

// const coffeeTotal = records
//   .filter(r => r.producttype === "coffee")
//   .reduce((s, r) => s + Number(r.weight), 0);

// const teaTotal = records
//   .filter(r => r.producttype === "tea leaves")
//   .reduce((s, r) => s + Number(r.weight), 0);

//   if (loading) {
//     return (
//       <div className="pa4 tc gray">
//         Loading dashboard...
//       </div>
//     );
//   }

  

//   return (
//     <div className="pa3">

//       {/* =====================
//           USER HEADER
//       ===================== */}
//       <div className="flex items-center mb4">

//         {/* ICON */}
//     <div
//   style={{
//     width: 60,
//     height: 60,
//     borderRadius: "50%",
//     overflow: "hidden",
//     marginRight: 12,
//     border: "2px solid #fc9c1c",
//   }}
// >
//   <img
//     src={getGenderAvatar(profile?.gender)}
//     alt="user avatar"
//     style={{
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//     }}
//   />
// </div>

//         {/* USER INFO */}
//         <div>
//           <div className="f4 b">
//             {profile?.username || "User"}
//           </div>
//        {profile?.status && (
//             <span
//               className={`dib br-pill ph2 pv1 f6 fw7 mv1 ${
//                 profile.status.toLowerCase() === "active"
//                   ? "bg-light-green dark-green"
//                   : "bg-light-red dark-red"
//               }`}
//             >
//               {profile.status.toLowerCase() === "active" ? "● Active" : "⛔ Suspended"}
//             </span>
//           )}
//           <div className="gray f6">
//             {profile?.company || "Company"}
//           </div>
//         </div>
//       </div>

//       {/* =====================
//           METRICS
//       ===================== */}
//       {/* <div className="flex flex-wrap justify-center gap4">

//         <CircularProgress
//           value={totalRecords}
//           max={recordsMax}
//           label="All Records"
//           color="#3b82f6"
//         />

//         <CircularProgress
//           value={monthlyRecords}
//           max={monthlyMax}
//           label="This Month"
//           color="#f59e0b"
//         />

//         <CircularProgress
//           value={approvedRecords}
//           max={approvedMax}
//           label="Approved"
//           color="#10b981"
//         />

//         <CircularProgress
//           value={Number(totalWeight)}
//           max={weightMax}
//           label="Total Weight"
//           color="#8b5cf6"
//         />
//       </div> */}

// <div className="bg-white br3 shadow-1 pa3 mb4">

//   {/* HEADER ROW WITH CARET */}
//   <div
//     className="flex items-center justify-between pointer"
//     onClick={() => setShowChart((prev) => !prev)}
//   >
//     <h3 className="f5 f4-l ma0">Daily Production Trend</h3>

//     <span
//       className="f4 gray"
//       style={{
//         transition: "transform 0.2s ease",
//         transform: showChart ? "rotate(0deg)" : "rotate(-90deg)",
//         display: "inline-block",
//       }}
//     >
//       ▾
//     </span>
//   </div>

//   {/* COLLAPSIBLE BODY */}
//   {showChart && (
//     <>
//       <ScrollableChart chartData={chartData} isMobile={isMobile}>
//         <div style={{ minWidth: isMobile ? Math.max(chartData.length * 60, 320) : "100%" }}>
//           <ResponsiveContainer width="100%" height={isMobile ? 240 : 320}>
//             <LineChart
//               data={chartData}
//               margin={
//                 isMobile
//                   ? { top: 5, right: 10, left: -20, bottom: 20 }
//                   : { top: 5, right: 20, left: 0, bottom: 5 }
//               }
//             >
//               <CartesianGrid strokeDasharray="3 3" />

//               <XAxis
//                 dataKey="date"
//                 tick={{ fontSize: isMobile ? 10 : 12 }}
//                 angle={isMobile ? -45 : 0}
//                 textAnchor={isMobile ? "end" : "middle"}
//                 height={isMobile ? 50 : 30}
//                 interval={isMobile ? "preserveStartEnd" : 0}
//               />

//               <YAxis
//                 domain={[0, "auto"]}
//                 tick={{ fontSize: isMobile ? 10 : 12 }}
//                 width={isMobile ? 35 : 45}
//               />

//               <Tooltip contentStyle={{ fontSize: isMobile ? 12 : 14 }} />

//               <Legend wrapperStyle={{ fontSize: isMobile ? 11 : 13 }} />

//               <Line type="monotone" dataKey="milk" stroke="#2563eb" strokeWidth={isMobile ? 2 : 4} dot={false} />
//               <Line type="monotone" dataKey="coffee" stroke="#ef4444" strokeWidth={isMobile ? 2 : 4} dot={false} />
//               <Line type="monotone" dataKey="tea" stroke="#22c55e" strokeWidth={isMobile ? 2 : 4} dot={false} />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       </ScrollableChart>

//       <div className="flex justify-center flex-wrap mt4">
//         <div className="pa2 pa3-l f6">
//           <span style={{ color: "#2563eb" }}>■</span> Milk ({milkTotal} kg)
//         </div>
//         <div className="pa2 pa3-l f6">
//           <span style={{ color: "#ef4444" }}>■</span> Coffee ({coffeeTotal} kg)
//         </div>
//         <div className="pa2 pa3-l f6">
//           <span style={{ color: "#22c55e" }}>■</span> Tea Leaves ({teaTotal} kg)
//         </div>
//         <div className="pa2 pa3-l f6">
//           All <b>({totalRecords})</b>
//         </div>
//         <div className="pa2 pa3-l f6">
//           Approved Records <b>({approvedRecords})</b>
//         </div>
//       </div>
//     </>
//   )}
// </div>
//     </div>
//   );
// }


// // TEMP: paste this above your `if (loading)` return, and swap
// // `records.forEach(...)` etc. to use `mockRecords` instead of `records`
// // for testing purposes only — remove once you're done.

// // function generateMockRecords(days = 25) {
// //   const types = ["milk", "coffee", "tea leaves"];
// //   const mock = [];
// //   let id = 1000;

// //   for (let i = days; i >= 0; i--) {
// //     const date = new Date();
// //     date.setDate(date.getDate() - i);

// //     types.forEach((type) => {
// //       mock.push({
// //         id: id++,
// //         farmerid: "GA012",
// //         producttype: type,
// //         weight: String(Math.floor(Math.random() * 50) + 5), // 5–55 kg
// //         companyname: "Gatamura Dairy",
// //         fullname: "Vin User",
// //         daterecorded: date.toISOString(),
// //         status: "null",
// //         approved_status: Math.random() > 0.2 ? "approved" : "pending",
// //         date_approved: date.toISOString(),
// //         edited_by: "Victor_e4HOsh",
// //         date_modified: date.toISOString(),
// //         username: "Vinuser",
// //         gender: "female",
// //         company: "Gatamura Dairy",
// //       });
// //     });
// //   }

// //   return mock;
// // }

// // const mockRecords = generateMockRecords(25); // 25 days × 3 products = 75 records


//   // =====================
// // Screen size hook
// // =====================
// function useIsMobile(breakpoint = 600) {
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth < breakpoint : false
//   );

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
//     window.addEventListener("resize", handleResize);
//     handleResize();
//     return () => window.removeEventListener("resize", handleResize);
//   }, [breakpoint]);

//   return isMobile;
// }


import { useEffect, useLayoutEffect, useState, useRef } from "react";
import Cookies from "js-cookie";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

// =====================
// Screen size hook
// =====================
function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
}

// =====================
// Circular Progress (not used right now, kept for later)
// =====================
function CircularProgress({ value, max, label, color }) {
  const radius = 50;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;
  const progress = max > 0 ? (value / max) * circumference : 0;

  return (
    <div className="tc">
      <svg width="120" height="120" className="mb3">
        <circle cx="60" cy="60" r={radius} stroke="#e5e7eb" strokeWidth={strokeWidth} fill="none" />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
        <text x="60" y="65" textAnchor="middle" className="f4 fw6 dark-gray">
          {value}
        </text>
      </svg>
      <div className="f6 gray">{label}</div>
    </div>
  );
}

// =====================
// Scrollable chart: opens on the NEWEST day (right edge),
// older days are a swipe to the left
// =====================
function ScrollableChart({ dataLength, bleed, children }) {
  const scrollRef = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: false });

  const measure = () => {
    const el = scrollRef.current;
    if (!el) return;
    setEdges({
      left: el.scrollLeft > 5,
      right: el.scrollLeft + el.clientWidth < el.scrollWidth - 5,
    });
  };

  // jump to the latest point before the first paint (no flicker), and once more
  // on the next frame in case the chart finished measuring its width late
  useLayoutEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const toEnd = () => {
      el.scrollLeft = el.scrollWidth;
      measure();
    };
    toEnd();
    const raf = requestAnimationFrame(toEnd);
    return () => cancelAnimationFrame(raf);
  }, [dataLength]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      el.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, []);

  const fade = (side) => ({
    position: "absolute",
    top: 0,
    bottom: 0,
    [side]: 0,
    width: "28px",
    pointerEvents: "none",
    background: `linear-gradient(to ${side === "left" ? "left" : "right"}, rgba(255,255,255,0), rgba(255,255,255,0.95))`,
  });

  return (
    <div style={{ margin: bleed ? "0 -8px" : 0 }}>
      <div style={{ position: "relative" }}>
        <div
          ref={scrollRef}
          style={{ width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" }}
        >
          {children}
        </div>
        {edges.left && <div aria-hidden="true" style={fade("left")} />}
        {edges.right && <div aria-hidden="true" style={fade("right")} />}
      </div>

      {(edges.left || edges.right) && (
        <div className="tc f7 gray mt1">
          {edges.right ? "← earlier · later →" : "← swipe for earlier days"}
        </div>
      )}
    </div>
  );
}

const typeOf = (r) => (r.producttype || "").toLowerCase();

// =====================
// Dashboard
// =====================
export default function RecordsDashboard() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const isMobile = useIsMobile();
  const [showChart, setShowChart] = useState(false);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const userid = Cookies.get("sessioniduser") || "";

      if (!userid) {
        setLoading(false);
        return;
      }

      const res = await fetch("https://api.terraweb.africa/getRecords", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid }),
      });

      const data = await res.json();

      // safety check (important)
      if (data?.profile) {
        setProfile(data.profile || {});
        setRecords(data.records || []);
      } else {
        // fallback for unexpected response
        setProfile({});
        setRecords([]);
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // =====================
  // DATE FILTER HELPERS
  // =====================
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const isThisMonth = (dateStr) => {
    const d = new Date(dateStr);
    return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  };

  // =====================
  // METRICS
  // =====================
  const totalRecords = records.length;

  const monthlyRecords = records.filter((r) => isThisMonth(r.daterecorded)).length;

  const approvedRecords = records.filter((r) => r.approved_status === "approved").length;

  const totalWeight = records
    .reduce((sum, r) => sum + (parseFloat(r.weight) || 0), 0)
    .toFixed(2);

  // dynamic max scaling (used by CircularProgress if you bring it back)
  const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;
  const monthlyMax = monthlyRecords > 0 ? monthlyRecords * 1.2 : 50;
  const approvedMax = totalRecords > 0 ? totalRecords : 100;
  const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100;

  const getGenderAvatar = (gender) => {
    switch (gender) {
      case "female":
        return "/img/femaleavatar.jpg";
      case "male":
        return "/img/maleavatar.jpeg";
      default:
        return "/img/maleavatar.png";
    }
  };

  // =====================
  // CHART DATA: one row per calendar day, oldest first, newest last.
  // Grouped by a real date key (not the "5 Jan" label) so the same day in
  // different years is never merged, and so it can be sorted properly.
  // =====================
  const grouped = {};

  records.forEach((r) => {
    const d = new Date(r.daterecorded);
    if (isNaN(d)) return;

    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    if (!grouped[key]) {
      grouped[key] = {
        ts: new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(),
        milk: 0,
        coffee: 0,
        tea: 0,
      };
    }

    const weight = Number(r.weight) || 0;

    switch (typeOf(r)) {
      case "milk":
        grouped[key].milk += weight;
        break;
      case "coffee":
        grouped[key].coffee += weight;
        break;
      case "tea leaves":
        grouped[key].tea += weight;
        break;
      default:
        break;
    }
  });

  const rows = Object.values(grouped).sort((a, b) => a.ts - b.ts);
  const multiYear = new Set(rows.map((r) => new Date(r.ts).getFullYear())).size > 1;

  const chartData = rows.map((r) => ({
    ...r,
    date: new Date(r.ts).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      ...(multiYear ? { year: "2-digit" } : {}),
    }),
  }));

  const sumType = (type) =>
    records.filter((r) => typeOf(r) === type).reduce((s, r) => s + (Number(r.weight) || 0), 0);

  const milkTotal = sumType("milk");
  const coffeeTotal = sumType("coffee");
  const teaTotal = sumType("tea leaves");

  if (loading) {
    return <div className="pa4 tc gray">Loading dashboard...</div>;
  }

  return (
    <div className="pa0 pa3-ns">
      {/* =====================
          USER HEADER
      ===================== */}
      <div className="flex items-center mb4">
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            overflow: "hidden",
            marginRight: 12,
            border: "2px solid #fc9c1c",
          }}
        >
          <img
            src={getGenderAvatar(profile?.gender)}
            alt="user avatar"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        <div>
          <div className="f4 b">{profile?.username || "User"}</div>
          {profile?.status && (
            <span
              className={`dib br-pill ph2 pv1 f6 fw7 mv1 ${
                profile.status.toLowerCase() === "active"
                  ? "bg-light-green dark-green"
                  : "bg-light-red dark-red"
              }`}
            >
              {profile.status.toLowerCase() === "active" ? "● Active" : "⛔ Suspended"}
            </span>
          )}
          <div className="gray f6">{profile?.company || "Company"}</div>
        </div>
      </div>

      {/* =====================
          DAILY PRODUCTION TREND
      ===================== */}
      <div className="bg-white br3 shadow-1 pa2 pa3-ns mb4">
        {/* HEADER ROW WITH CARET */}
        <div
          className="flex items-center justify-between pointer"
          onClick={() => setShowChart((prev) => !prev)}
        >
          <h3 className="f5 f4-l ma0">Daily Production Trend</h3>

          <span
            className="f4 gray"
            style={{
              transition: "transform 0.2s ease",
              transform: showChart ? "rotate(0deg)" : "rotate(-90deg)",
              display: "inline-block",
            }}
          >
            ▾
          </span>
        </div>

        {/* COLLAPSIBLE BODY */}
        {showChart && (
          <>
            <ScrollableChart dataLength={chartData.length} bleed={isMobile}>
              {/* on phones every day gets 60px so labels never collide; the chart scrolls */}
              <div style={{ minWidth: isMobile ? chartData.length * 60 : undefined }}>
                <ResponsiveContainer width="100%" height={isMobile ? 240 : 320}>
                  <LineChart
                    data={chartData}
                    margin={
                      isMobile
                        ? { top: 5, right: 16, left: -20, bottom: 20 }
                        : { top: 5, right: 20, left: 0, bottom: 5 }
                    }
                  >
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                      dataKey="date"
                      tick={{ fontSize: isMobile ? 10 : 12 }}
                      angle={isMobile ? -45 : 0}
                      textAnchor={isMobile ? "end" : "middle"}
                      height={isMobile ? 50 : 30}
                      interval={0}
                      padding={{ left: 8, right: 12 }}
                    />

                    <YAxis
                      domain={[0, "auto"]}
                      tick={{ fontSize: isMobile ? 10 : 12 }}
                      width={isMobile ? 35 : 45}
                    />

                    <Tooltip contentStyle={{ fontSize: isMobile ? 12 : 14 }} />

                    <Legend wrapperStyle={{ fontSize: isMobile ? 11 : 13 }} />

                    <Line type="monotone" dataKey="milk" stroke="#2563eb" strokeWidth={isMobile ? 2 : 4} dot={false} />
                    <Line type="monotone" dataKey="coffee" stroke="#ef4444" strokeWidth={isMobile ? 2 : 4} dot={false} />
                    <Line type="monotone" dataKey="tea" stroke="#22c55e" strokeWidth={isMobile ? 2 : 4} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </ScrollableChart>

            <div className="flex justify-center flex-wrap mt4">
              <div className="pa2 pa3-l f6">
                <span style={{ color: "#2563eb" }}>■</span> Milk ({milkTotal} kg)
              </div>
              <div className="pa2 pa3-l f6">
                <span style={{ color: "#ef4444" }}>■</span> Coffee ({coffeeTotal} kg)
              </div>
              <div className="pa2 pa3-l f6">
                <span style={{ color: "#22c55e" }}>■</span> Tea Leaves ({teaTotal} kg)
              </div>
              <div className="pa2 pa3-l f6">
                All <b>({totalRecords})</b>
              </div>
              <div className="pa2 pa3-l f6">
                Approved Records <b>({approvedRecords})</b>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}